var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 12.465,
    x2: 12.465,
    y1: 1.25,
    y2: 22.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#5d636b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#5d636b",
    offset: 1
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.93 22.75c-.48 0-.96-.12-1.4-.37-.89-.5-1.42-1.39-1.42-2.4v-5.35c0-.51-.33-1.26-.64-1.65l-3.8-3.99c-.63-.63-1.12-1.73-1.12-2.54V4.13c0-1.61 1.22-2.87 2.77-2.87h13.33a2.77 2.77 0 0 1 2.77 2.77v2.22c0 1.05-.63 2.26-1.23 2.85-.29.29-.77.29-1.06 0s-.29-.77 0-1.06c.37-.37.79-1.2.79-1.79V4.03c0-.7-.57-1.27-1.27-1.27H5.33c-.71 0-1.27.6-1.27 1.37v2.32c0 .37.3 1.1.69 1.49l3.85 4.05c.51.63 1.01 1.69 1.01 2.64v5.35c0 .66.45.98.65 1.09.43.24.94.23 1.34-.01l1.4-.9c.35-.22.81-.12 1.04.23.22.35.12.81-.23 1.04l-1.41.91c-.45.27-.96.41-1.47.41z",
    fill: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.88 20.25c-1.92 0-3.73-1.02-4.71-2.67-.52-.84-.79-1.82-.79-2.83 0-3.03 2.47-5.5 5.5-5.5s5.5 2.47 5.5 5.5c0 1.01-.28 1.99-.8 2.84-.97 1.64-2.77 2.66-4.7 2.66zm0-9.5c-2.21 0-4 1.79-4 4 0 .73.2 1.44.58 2.05a3.995 3.995 0 0 0 3.42 1.95c1.42 0 2.7-.72 3.42-1.94.38-.62.58-1.33.58-2.06 0-2.21-1.79-4-4-4z",
    fill: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.15 16.74c-.19 0-.38-.07-.53-.22l-2.51-2.51c-.29-.29-.29-.77 0-1.06s.77-.29 1.06 0l2.51 2.51c.29.29.29.77 0 1.06a.71.71 0 0 1-.53.22z",
    fill: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.62 16.77c-.19 0-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l2.51-2.51c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-2.51 2.51c-.15.15-.34.22-.53.22z",
    fill: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.93 22.75c-.48 0-.96-.12-1.39-.36-.89-.5-1.42-1.4-1.42-2.41v-5.35c0-.5-.33-1.26-.65-1.65l-3.8-3.99c-.63-.65-1.12-1.74-1.12-2.54V4.12c0-1.61 1.22-2.87 2.77-2.87h13.34a2.77 2.77 0 0 1 2.77 2.77v2.22c0 1.05-.62 2.23-1.22 2.85l-1.8 1.59c-.18.16-.44.22-.67.17-.27-.07-.56-.1-.86-.1-2.21 0-4 1.79-4 4 0 .73.2 1.44.58 2.06.32.53.75.97 1.25 1.28.22.14.36.38.36.64v.34c0 .79-.48 1.9-1.28 2.37l-1.38.89c-.45.28-.97.42-1.48.42zm-5.6-20c-.71 0-1.27.6-1.27 1.37v2.33c0 .36.3 1.1.7 1.5L8.61 12c.51.63 1.02 1.7 1.02 2.64v5.35c0 .66.46.99.65 1.1.43.24.94.23 1.33-.01l1.4-.9c.27-.16.54-.67.56-1.03-.55-.41-1.03-.94-1.39-1.54-.52-.85-.8-1.83-.8-2.83a5.51 5.51 0 0 1 6.32-5.44l1.48-1.31c.34-.35.76-1.18.76-1.77V4.04c0-.7-.57-1.27-1.27-1.27H5.33z",
    fill: "",
    opacity: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilter);
export default __webpack_public_path__ + "static/media/clear-filter.e320925b4766e3341b7a177f6c33292f.svg";
export { ForwardRef as ReactComponent };